<template>
  <a-layout-footer class="foot">
    {{platformValue}}
  </a-layout-footer>
</template>

<script>
import {listPlatformConfig} from '@/api/serviceHall/serviceHall'
import storage from "store";
import {ACCESS_TOKEN} from "@/store/mutation-types";

export default {
  name: 'HallFooter',
  data() {
    return {
      platformValue: undefined
    }
  },
  created() {
    const token = storage.get(ACCESS_TOKEN)
    if (token) {
      this.listPlatformConfig()
    }
  },
  methods: {
    listPlatformConfig() {
      listPlatformConfig().then(res => {
        if (res.success) {
          const platform = res.data.filter(item => item.code === 'PLATFORM_FOOTER_VERSION_INFORMATION')
          this.platformValue = platform[0].value
          console.log('platformValue', this.platformValue)
        }
      })
    }
  }
}
</script>

<style scoped lang="less">
.foot {
  padding: 0;
  line-height: 40px;
  background-color: #000000;
  text-align: center;
  color: #d6d6d6;
  font-size: 14px;
}
</style>
